import * as update from "immutability-helper";
import * as DTOS from "../FeralScan.dtos";
import { 
    AdminAction, 
    ADMIN_EDIT_USER_SUCCESS, 
    ADMIN_SEARCH_PLOTS_SUCCESS, 
    ADMIN_SEARCH_USERS_SUCCESS, 
    ADMIN_SEARCH_USERS_REQUEST, 
    ADMIN_GET_SINGLE_USER_REQUEST, 
    ADMIN_GET_SINGLE_USER_SUCCESS, 
    IGetSingleUserSuccess, 
    ADMIN_EDIT_USER_REQUEST, 
    ADMIN_SEARCH_PLOTS_REQUEST, 
    ADMIN_SEARCH_USER_ROLES_REQUEST, 
    ADMIN_SEARCH_USER_ROLES_SUCCESS, 
    ADMIN_BATCH_IMPORT_REQUEST, 
    ADMIN_BATCH_IMPORT_SUCCESS, 
    IBatchAdminImportSuccess, 
    ADMIN_BATCH_IMPORT_FAIL, 
    ADMIN_SEARCH_FILES_REQUEST, 
    ADMIN_SEARCH_FILES_SUCCESS, 
    ADMIN_GET_PLOT_METAINFO_REQUEST, 
    ADMIN_GET_PLOT_METAINFO_SUCCESS, 
    IGetPlotMetaInfoSuccess, 
    ADMIN_BATCH_IMPORT_CLEAR_ERROR, 
    IBatchAdminImportClearError, 
    IBatchAdminImportFail, 
    ADMIN_EDIT_USER_FAILURE
} from "../actions/admin.actions";

interface IPlotMetaInfo {
    apcCodes: string[];
    waterBodys: string[];
    users: DTOS.User[];
    userRoles: DTOS.UserRole[];
}

export type AdminState = {
    batchImportProcessing: boolean;
    batchImportReponse: any;
    files: DTOS.FileRecord[];
    filesLoading: boolean;
    plotMetaInfo: IPlotMetaInfo;
    plotMetaInfoLoading: boolean;
    plots: DTOS.Plot[];
    plotsLoading: boolean;
    users: DTOS.User[];
    usersLoading: boolean;
    userGroups: DTOS.UserGroup[];
    userRoles: DTOS.UserRole[];
    userRolesLoading: boolean;
    userSaving: boolean;
}

const initialState: AdminState = {
    plotMetaInfo: undefined,
    plotMetaInfoLoading: false,
    batchImportProcessing: false,
    batchImportReponse: undefined,
    files: undefined,
    filesLoading: false,
    users: undefined,
    usersLoading: false,
    userGroups: undefined,
    userSaving: false,
    userRoles: undefined,
    userRolesLoading: false,
    plots: undefined,
    plotsLoading: false,
};


export default function survey(state: AdminState = initialState, action) {
    switch (action.type) {
        case ADMIN_SEARCH_USERS_REQUEST:
            return searchingUsers(state);
        case ADMIN_SEARCH_USERS_SUCCESS:
            return updateUsers(state, action);
        case ADMIN_SEARCH_USER_ROLES_REQUEST:
            return searchingUserRoles(state);
        case ADMIN_SEARCH_USER_ROLES_SUCCESS:
            return updateUserRoles(state, action);
        case ADMIN_GET_PLOT_METAINFO_REQUEST:
            return updatePlotMetaLoading(state, true);
        case ADMIN_GET_PLOT_METAINFO_SUCCESS:
            return updatePlotMeta(state, action);
        case ADMIN_GET_SINGLE_USER_REQUEST:
            return updateUsersLoading(state, true);
        case ADMIN_GET_SINGLE_USER_SUCCESS:
            return updateSingleUser(state, action);
        case ADMIN_EDIT_USER_REQUEST:
            return updateUserSaving(state, true);
        case ADMIN_EDIT_USER_SUCCESS:
            return updateUserSaved(state, action);
        case ADMIN_EDIT_USER_FAILURE:
            return updateUserSaving(state, false);
        case ADMIN_SEARCH_PLOTS_REQUEST:
            return searchingPlots(state);
        case ADMIN_SEARCH_PLOTS_SUCCESS:
            return updatePlots(state, action);
        case ADMIN_SEARCH_FILES_REQUEST:
            return searchingFiles(state);
        case ADMIN_SEARCH_FILES_SUCCESS:
            return updateFiles(state, action);
        case ADMIN_BATCH_IMPORT_REQUEST:
            return updateBatchImportProcessing(state, true);
        case ADMIN_BATCH_IMPORT_SUCCESS:
            return updateBatchImportReponse(state, action);
        case ADMIN_BATCH_IMPORT_FAIL:
            return updateBatchImportReponse(state, action);
        case ADMIN_BATCH_IMPORT_CLEAR_ERROR:
            return updateBatchImportReponse(state, action);
    }
    return state;

}

function updateBatchImportReponse(state: AdminState, action: IBatchAdminImportSuccess | IBatchAdminImportFail) {

    const response = action.response ? action.response : undefined;

    const newState = update(state, {
        batchImportReponse: { $set: response }
    });

    return updateBatchImportProcessing(newState, false);
}

function updateBatchImportProcessing(state: AdminState, processing: boolean) {
    const newState = update(state, {
        batchImportProcessing: { $set: processing }
    });

    return newState
}

function savePlots(state: AdminState, action: AdminAction) {
    return update(state, {
        plots: { $set: action.plots }
    });
}

function searchingPlots(state: AdminState) {
    const newState = update(state, {
        plots: { $set: undefined }
    });

    return updatePlotsLoading(newState, true);
}

function updatePlots(state: AdminState, action) {
    const newState = update(state, {
        plots: { $set: action.plots }
    });

    return updatePlotsLoading(newState, false);
}

function searchingFiles(state: AdminState) {
    const newState = update(state, {
        files: { $set: undefined }
    });

    return updateFilesLoading(newState, true);
}

function updateFiles(state: AdminState, action) {
    const newState = update(state, {
        files: { $set: action.files }
    });

    return updateFilesLoading(newState, false);
}

function updatePlotMeta(state: AdminState, action: IGetPlotMetaInfoSuccess) {

    const newMetaInfo: IPlotMetaInfo = {
        apcCodes: action.apcCodes,
        waterBodys: action.waterBodys,
        users: action.users,
        userRoles: action.userRoles
    }

    const newState = update(state, {
        plotMetaInfo: { $set: newMetaInfo }
    });

    return updatePlotMetaLoading(newState, false);
}

function searchingUsers(state: AdminState) {
    const newState = update(state, {
        users: { $set: undefined }
    });

    return updateUsersLoading(newState, true);
}

function searchingUserRoles(state: AdminState) {
    const newState = update(state, {
        userRoles: { $set: undefined }
    });

    return updateUserRolesLoading(newState, true);
}


function updateSingleUser(state: AdminState, action: IGetSingleUserSuccess) {
    var newState: AdminState = state;
    const user = action.user;

    if (state.users) {
        const index = state.users.findIndex(u => u.id === user.id);
        if (index === -1) {
            newState = update(state, {
                users: { $push: [user] }
            });
        } else {
            newState = update(state, {
                users: {
                    [index]: {
                        $set: user
                    }
                }
            });
        }
    } else {
        newState = update(state, {
            users: { $set: [user] }
        });
    }

    return updateUsersLoading(newState, false);
}

function updateUsers(state: AdminState, action) {
    const newState = update(state, {
        users: { $set: action.users }
    });

    return updateUsersLoading(newState, false);
}

function updateUserRoles(state: AdminState, action) {
    const newState = update(state, {
        userRoles: { $set: action.userRoles }
    });

    return updateUserRolesLoading(newState, false);
}

function updatePlotsLoading(state: AdminState, loading) {
    return update(state, {
        plotsLoading: { $set: loading }
    })
}

function updateFilesLoading(state: AdminState, loading) {
    return update(state, {
        filesLoading: { $set: loading }
    })
}

function updateUsersLoading(state: AdminState, loading) {
    return update(state, {
        usersLoading: { $set: loading }
    })
}

function updateUserRolesLoading(state: AdminState, loading) {
    return update(state, {
        userRolesLoading: { $set: loading }
    })
}

function updatePlotMetaLoading(state: AdminState, loading) {
    return update(state, {
        plotMetaInfoLoading: { $set: loading }
    })
}

function updateUserSaving(state: AdminState, saving) {
    return update(state, {
        userSaving: { $set: saving }
    })
}

function updateUserSaved(state: AdminState, action) {
    const newState = updateUserSaving(state, false);

    return updateSingleUser(newState, action);
}

function saveUserGroups(state: AdminState, action: AdminAction) {
    return update(state, {
        userGroups: { $set: action.groups }
    });
}
